import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance.js";

export const fetchTeacherScore = createAsyncThunk(
  "teacherScore/fetch",
  async (_, thunkAPI) => {
    try {
      const { data } = await axiosInstance.get("/teacher/score");
      // console.log(data);

      return data; // { score: N }
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
